import selectDialogList from './role.select.dialog.list';
import list from './list';
import form from './form';
import activeRoleTree from './activeRoleTree';
import roleUserList from './role.user.list'
import roleDependencyRelation from './role.dependency.relation'
import rolePermissionPlatformList from './role.permission.platform.list'
import rolePermissionBackendList from './role.permission.backend.list';

export default {

    namespaced: true,

    modules: {
        'selectDialogList': selectDialogList,
        'activeRoleTree': activeRoleTree,
        'rolePermissionPlatformList': rolePermissionPlatformList,
        'rolePermissionBackendList': rolePermissionBackendList,
        'roleUserList': roleUserList,
        'roleDependencyRelation': roleDependencyRelation,
        'list': list,
        'form': form,
    },

}
